export enum Country {
    POLAND = 1,
    SPAIN = 2
}
